import { service } from '../api/axios';

export const getPinnedActivities = async () => {
  const response = await service.get('/pinnedActivities', {});
  return response.data;
};

export const setPinnedActivity = async (postId: string, pinned: boolean) => {
  const response = await service.put(`/posts/${postId}/setpinned`, { pinned });
  return response.data;
};
